module.exports = __webpack_public_path__ + "img/d-icon-gift.38993f1.webp";